<template>
  <v-container fluid class="pb-0">
    <div>
      <template>
        <v-row class="h-100">
          <v-col cols="7" class="pt-1 pb-0">
            <AnalysisCotizacion></AnalysisCotizacion>
          </v-col>
          <v-col cols="5" class="pt-1 pb-0">
            <PatientCotizacion></PatientCotizacion>
          </v-col>
        </v-row>
      </template>
    </div>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";

import AnalysisCotizacion from "../../../components/analysis/CatalogueCotizaciones";
import PatientCotizacion from "../../../components/cotizacion/PatientDetail";
//import ClosedTill from '../../../components/tills/ClosedTill';

export default {
  name: "NewRequest",
  components: {
    AnalysisCotizacion,
    PatientCotizacion,
  },
  data() {
    return {
      itemsBreadcrumbs: [
        {
          text: "Ventas",
          disabled: true,
          href: "",
        },
      ],
    };
  },
  computed: {
    ...mapState("sales", ["status_operation"]),
    ...mapState("authentication", ["office_id", "till_user_id"]),
    ...mapState("tills", ["tills", "selected_till"]),
  },
  methods: {
    ...mapActions("sales", ["run_set_status_operation"]),
    ...mapActions("tills", ["getAvailable", "select_till"]),
    ...mapActions("accounts", ["getAccounts"]),
    handleCloseMessageValidation() {
      this.run_set_status_operation(false);
    },
    async getCurrentUserTill() {
      let filters = {
        till_id: this.till_user_id,
      };
      await this.getAvailable(filters);
      if (this.tills.length > 0) {
        this.select_till(this.tills[0]);
      }
    },
  },
  created() {
    // this.getCurrentUserTill();
    // this.getAccounts();
  },
  mounted() {
    this.run_set_status_operation(false);
  },
};
</script>

<style scoped></style>
